// 右側小紅帽角色 Spine 載入與工廠 — 沿用 Unity 來源 Art/Animaton/ani_character（Spine 4.2.43，3 張 pma:true 圖集頁）。
// 動畫名取自 Unity LandscapeUI.prefab 的 GamePlayUI 序列化欄位（_characterWinAnimations/_characterUpgradeAnimations/
// _bigCharacterShowAnimations）與 Scene 覆寫的待機動畫（第一手核對）：
//   主遊戲：待機 small_idle(loop)、可愛穿插 small_cute、贏分 small_happy、進 FG 變身 small_upgrade→big1_show。
//   免費遊戲（依 Scatter 計量等級 1~4）：待機 big{n}_idle、贏分 big{n}_win（Lv4 用 big4_lv1_win）、
//   升級 big{n-1}_upgrade（升 Lv2/3/4 → big1/2/3_upgrade）。

import { Assets } from 'pixi.js'
import { Spine } from '@esotericsoftware/spine-pixi-v8'
import { isSpinePrimed, primeSpineAssets } from '../../framework/assets/spineBundle'

const SKEL = '/spine/character/ani_character.skel'
const ATLAS = '/spine/character/ani_character.atlas'
const DEF = { skel: SKEL, atlas: ATLAS }

export const CHARACTER_ANIM = {
  idle: 'small_idle',
  cute: 'small_cute',
  win: 'small_happy',
  upgrade: 'small_upgrade',
  /** 進 FG 由小變大登場（small_upgrade 之後接續）。 */
  bigShow: 'big1_show',
  /** FG 待機（index=等級-1）。 */
  fgIdle: ['big1_idle', 'big2_idle', 'big3_idle', 'big4_lv1_idle'],
  /** FG 贏分（index=等級-1；對照 Unity _characterWinAnimations[GetLevel]）。 */
  fgWin: ['big1_win', 'big2_win', 'big3_win', 'big4_lv1_win'],
  /** FG 升級（升到等級 n 播 index=n-2；對照 Unity _characterUpgradeAnimations[checkLevel-1]）。 */
  fgUpgrade: ['big1_upgrade', 'big2_upgrade', 'big3_upgrade'],
} as const

let loaded = false

/** 載入角色骨骼 + 圖集。第一次畫面前呼叫（見 main.ts）。優先走 spine bundle，缺 bundle 才抓散檔。 */
export async function loadCharacterSpine(): Promise<void> {
  if (loaded) return
  await primeSpineAssets([DEF])
  if (!isSpinePrimed(DEF)) {
    Assets.add({ alias: SKEL, src: SKEL })
    Assets.add({ alias: ATLAS, src: ATLAS })
    await Assets.load([SKEL, ATLAS])
  }
  loaded = true
}

/** 建立角色 Spine 顯示物件（失敗回傳 null，讓呼叫端退回靜態立繪）。 */
export function createCharacterSpine(): Spine | null {
  try {
    return Spine.from({ skeleton: SKEL, atlas: ATLAS })
  } catch {
    return null
  }
}
